export const Network = (props) => {
  return (
    <div id='network'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-md-6'>
            {' '}
            <img src='img/network.jpg' className='img-responsive' alt='' />{' '}
          </div>
          <div className='col-xs-12 col-md-6'>
            <div className='about-text'>
              <h2>Our Network</h2>
              <p>{props.data ? props.data.paragraph1 : 'loading...'}</p>
              <div className='about-text'>
                <p>{props.data ? props.data.paragraph2 : 'loading...'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
